export enum KeyButtonList {
  DELETE = 'Delete',
  BACKSPACE = 'Backspace',
  TAB = 'Tab',
}
